import { frontendURL } from 'dashboard/helper/URLHelper';
import { whatsappFlowsMeta as meta } from '../campaigns/campaigns.routes';

const redirectTo = name => to => ({ name, params: to.params });

const WhatsappFlowsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows/follow_ups/new'),
      redirect: redirectTo('follow_up_flow_new'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp_flows/follow_ups/:flowId/edit'
      ),
      redirect: redirectTo('follow_up_flow_edit'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp_flows/follow_ups/:flowId/analytics'
      ),
      redirect: redirectTo('follow_up_flow_analytics'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/campaigns/multi_step/:flowId/edit'
      ),
      name: 'whatsapp_flow_edit',
      meta,
      component: () => import('./Edit.vue'),
    },
    {
      path: frontendURL(
        'accounts/:accountId/campaigns/multi_step/:flowId/tree'
      ),
      name: 'whatsapp_flow_tree',
      meta,
      component: () => import('./FlowTreePage.vue'),
    },
    // Legacy URLs, kept so old links keep working
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows'),
      redirect: redirectTo('campaigns_multi_step_index'),
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows/:flowId/edit'),
      redirect: redirectTo('whatsapp_flow_edit'),
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows/:flowId/tree'),
      redirect: redirectTo('whatsapp_flow_tree'),
    },
  ],
};

export default WhatsappFlowsRoutes;
